module.exports = __webpack_public_path__ + "static/media/lucas.1b84120b.jpg";